import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { QueryOptions } from '@app/model/query-options';
import { RecruiterService } from '@app/services/recruiterService';
import { Messages } from '@app/constants/constant';
import { TechnologyService } from '@app/services/technology.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {


  @ViewChild('fileInput', { static: false })
  myFileInput: ElementRef;

  display: boolean = false;
  interviewerList: any;
  first: number = 0;
  pageSize: number = 500;
  technologyList: any;
  fileToUpload: File | null = null;
  tableDataSet: any = new Map();
  datesArray: any = [];
  informationDate: any;
  scheduleUpload: any;
  dateCounter: number = 1;

  technologyQuery = null;
  interviewerQuery = null;


  showDialog() {
    this.display = true;
  }

  constructor(
    private _recruiterService: RecruiterService,
    private _apiTechnology: TechnologyService,
    private httpClient: HttpClient,
    private _toastService: MessageService,
    private _DatePipe: DatePipe,
    private spinner: NgxSpinnerService

  ) {

  }

  user: any;
  ngOnInit() {

    this.setTableHeaderDates();
    var sortParamsRecruiter = this.queryParams(false, "firstName");
    this._recruiterService.list(sortParamsRecruiter, Messages.endpoint.Recruiter).subscribe((res : any) => {
      this.interviewerList = res;
      console.log(this.interviewerList, 67);
    });

    //  const params = this.queryParamsDropDownFilter();
    //  this._apiTechnology.list(params).subscribe(res => {
    //    console.log
    //    this.technologyList = res;
    // });

     this.httpClient.get(environment.apiUrl+"/technology/technology-group").subscribe((res : any) =>{
       var count = 1;
       res = res.map(item => {
        return {
        id: count++,
        label:item        
        }        
        })
        res.unshift({
          id : 0,
          label : "Select"
        }) 
        console.log(res);
      this.technologyList = res;
     });
     console.log(JSON.parse(localStorage.getItem("currentUser")).user , 88)
     //Removing access on the badsis of role... role id = 4 means interviewer
     if(JSON.parse(localStorage.getItem("currentUser")).user.role.id == 4){
      this.getDashboarData(JSON.parse(localStorage.getItem("currentUser")).user.id);
     }
     else{
    this.getDashboarData();
     }

    // this.user = [
    //   {
    //     "InterviwerName": "Aditya Kumar",
    //     "Technology": "JAVA",
    //     "day1": "3PM - Rahul Chauhan",
    //     "day2": "4PM - Shilpi Agarwal",
    //     "day3": "11AM - Amit Kumar",
    //     "day4": "Not Available",
    //     "day5": "11AM",
    //     "day6": "5PM",
    //     "day1Class": "status-scheduled",
    //     "day2Class": "status-scheduled",
    //     "day3Class": "status-scheduled",
    //     "day4Class": "status-not-available",
    //     "day5Class": "status-available",
    //     "day6Class": "status-available",
    //   },
    //   {
    //     "InterviwerName": "Kapil Khanna",
    //     "Technology": "All",
    //     "day1": "Not Available",
    //     "day2": "Not Available",
    //     "day3": "11AM - Amit Kumar",
    //     "day4": "Not Available",
    //     "day5": "2PM",
    //     "day6": "5PM",
    //     "day1Class": "status-not-available",
    //     "day2Class": "status-not-available",
    //     "day3Class": "status-scheduled",
    //     "day4Class": "status-not-available",
    //     "day5Class": "status-available",
    //     "day6Class": "status-available",
    //   },
    //   {
    //     "InterviwerName": "Akhil Sharma",
    //     "Technology": "Dot Net",
    //     "day1": "3PM",
    //     "day2": "4PM",
    //     "day3": "11AM",
    //     "day4": "12PM",
    //     "day5": "11AM - Shilpi Agarwal",
    //     "day6": "5PM - Rahul Chauhan",
    //     "day1Class": "status-available",
    //     "day2Class": "status-available",
    //     "day3Class": "status-available",
    //     "day4Class": "status-available",
    //     "day5Class": "status-scheduled",
    //     "day6Class": "status-scheduled",
    //   },
    //   {
    //     "InterviwerName": "Akhil Sharma",
    //     "Technology": "Dot Net",
    //     "day1": "5PM",
    //     "day2": "6PM",
    //     "day3": "5PM - Amit Kumar",
    //     "day4": "4PM",
    //     "day5": "2PM - Shilpi Agarwal",
    //     "day6": "4PM - Rahul Chauhan",
    //     "day1Class": "status-available",
    //     "day2Class": "status-available",
    //     "day3Class": "status-scheduled",
    //     "day4Class": "status-available",
    //     "day5Class": "status-scheduled",
    //     "day6Class": "status-scheduled",
    //   },
    //   {
    //     "InterviwerName": "Ravi Ranjan",
    //     "Technology": "Business Development",
    //     "day1": "Not Available",
    //     "day2": "4PM - Shilpi Agarwal",
    //     "day3": "11AM",
    //     "day4": "Not Available",
    //     "day5": "11AM",
    //     "day6": "5PM",
    //     "day1Class": "status-not-available",
    //     "day2Class": "status-scheduled",
    //     "day3Class": "status-available",
    //     "day4Class": "status-not-available",
    //     "day5Class": "status-available",
    //     "day6Class": "status-available",
    //   },
    //   {
    //     "InterviwerName": "Anurag Thakur",
    //     "Technology": "Front-End",
    //     "day1": "3PM - Rahul Chauhan",
    //     "day2": "4PM",
    //     "day3": "11AM - Amit Kumar",
    //     "day4": "6PM - Shilpi Agarwal",
    //     "day5": "Not Available",
    //     "day6": "Not Available",
    //     "day1Class": "status-scheduled",
    //     "day2Class": "status-available",
    //     "day3Class": "status-scheduled",
    //     "day4Class": "status-scheduled",
    //     "day5Class": "status-not-available",
    //     "day6Class": "status-not-available",
    //   },
    // ]
  }
  clearFilters(interviewer: any, technology: any) {
    this.getDashboarData();
    interviewer.writeValue(0);
    technology.writeValue(0);
    this.dateCounter = 1;
  }

  setTableHeaderDates(offset = 1) {
    this.datesArray[0] = new Date().toDateString();
    for (let index = offset; index <= offset + 4; index++) {
      this.datesArray[index - offset + 1] = ((new Date((new Date).setDate((new Date).getDate() + index))).toDateString());
    }
  }

  nextData(counter: number) {
    this.dateCounter += counter;
    if (this.dateCounter > 0) {
      this.setTableHeaderDates(this.dateCounter)
      let currentDate = new Date();
      let dateRangeArray = []
      dateRangeArray.push(currentDate.setDate(currentDate.getDate() + this.dateCounter))
      dateRangeArray.push(currentDate.setDate(currentDate.getDate() + 4))
      this.getDashboarData(this.interviewerQuery, this.technologyQuery, dateRangeArray)
    }
    else {
      this.dateCounter = 1;
    }
  }
  
  getDashboarData(interviewer: any = "", technology: any = "", dateRange: any = "") {
    this.spinner.show();
    console.log(technology);
    technology = technology === 'Select' ? '' : technology;
    this.technologyQuery = technology;
    this.interviewerQuery = interviewer;
    
    this.tableDataSet = new Map()
    interviewer = Array.isArray(interviewer) ? interviewer.join(",") : interviewer;
    technology = Array.isArray(technology) ? technology.join(",") : technology;
    let dateRangeArray = new Array();
    if (dateRange && dateRange.length > 1) {
      dateRangeArray.push(this._DatePipe.transform(dateRange[1], 'dd/MM/yyyy'));
      dateRangeArray.push(this._DatePipe.transform(dateRange[0], 'dd/MM/yyyy'));
    }

    let qs = ""
    qs = interviewer != "" ? "interviewers=" + interviewer + "&" : qs;
    qs = technology != "" ? qs + "technology=" + technology + "&" : qs;
    qs = dateRangeArray.length > 1 ? qs + "dateRange=" + dateRangeArray[0] + '-' + dateRangeArray[1] : qs;

    this.httpClient
      .get(`${environment.apiUrl}/interview/dashboard-data?size=999&${qs}`).subscribe(res => {
        this.spinner.hide();
        this.user = res;
        if (Array.isArray(res) && res.length > 0) {
          this.informationDate = res[0].informationDate;
          this.scheduleUpload = res[0].scheduleUpload;
        }
        let today: any = new Date() 
        today.setDate(today.getDate() + this.dateCounter)
        let counter = 0;
        this.user.forEach((e) => {
          let tableDataKey = e.interviewerName.trim().toLowerCase() + " " + e.technologyName.trim().toLowerCase()
          //+ new Date(e.date).toLocaleDateString('en-IN')
          //new Date(e.date).getHours() + new Date(e.date).getMinutes();
          let data: any = {};
          let elementDate: any = new Date(e.date)
          let diffDays = 0;
          if (elementDate.toLocaleDateString("en-US") == new Date().toLocaleDateString("en-US")) {
            diffDays = 1
          } else {
            diffDays = (new Date(new Date(elementDate).toLocaleDateString("en-US")).getTime() - new Date(today.toLocaleDateString("en-US")).getTime()) / (1000*60*60*24) + 2;
          }
          let minuteValue = ("0" + elementDate.getMinutes()).slice(-2)

          if (this.tableDataSet.has(tableDataKey)) {
            data = this.tableDataSet.get(tableDataKey)
            if (data["day" + diffDays] != "Not Available") {
              tableDataKey = e.interviewerName.trim().toLowerCase() + e.technologyName.trim().toLowerCase() + counter;
              counter++;
              if (this.tableDataSet.has(tableDataKey)) {
                data = this.tableDataSet.get(tableDataKey)
              }
              else {
                data = {};
                data["InterviwerName"] = e.interviewerName;
                data["Technology"] = e.technologyName;
                for (let i = 1; i <= 6; i++) {
                  data["day" + i] = "Not Available"
                  data["day" + i + "Class"] = "status-not-available"
                }  
              }
            }
          }
          
          else {
            data["InterviwerName"] = e.interviewerName;
            data["Technology"] = e.technologyName;
            for (let i = 1; i <= 6; i++) {
              data["day" + i] = "Not Available"
              data["day" + i + "Class"] = "status-not-available"
            }
          }

          

          data["day" + diffDays] = elementDate.getHours() > 12 ? elementDate.getHours() % 12 + ":" + minuteValue + "PM" : elementDate.getHours() + ":" + minuteValue + "AM";
          data["day" + diffDays + "Class"] = "status-available"


          if (elementDate.getHours() == 12) {
            data["day" + diffDays] = elementDate.getHours() + ":" + minuteValue + "PM";
          }

          // if (e.ism && (e.ism.interviewStepStatus.id == "1" || e.ism.interviewStepStatus.id == "2")) {
          //   data["day" + diffDays] += " - " + e.primaryRecruiterName;
          //   data["day" + diffDays + "Class"] = "status-scheduled"
          // }

          if ((e.leave == 0 || e.leave == -1) && (e.interviewStepStatus == "1" || e.interviewStepStatus == "2")) {
            data["day" + diffDays] += " - " + e.primaryRecruiterName;
            data["day" + diffDays + "Class"] = e.leave == 1 ? "status-on-leave" : "status-scheduled"
          }
          else if (e.leave == 1 && (e.interviewStepStatus == "1" || e.interviewStepStatus == "2")) {
            data["day" + diffDays] += " - " + e.primaryRecruiterName;
            data["day" + diffDays + "Class"] = "status-on-leave"
          }
        
          else if (e.leave == 1) {
            data["day" + diffDays] = elementDate.getHours() > 12 ? elementDate.getHours() % 12 + ":" + minuteValue + "PM" : elementDate.getHours() + ":" + minuteValue + "AM";

            data["day" + diffDays + "Class"] = "status-on-leave"
          }
          else if (e.leave == 0) {
            data["day" + diffDays + "Class"] = "status-available"

          }

          this.tableDataSet.set(tableDataKey, data)
        })
        this.user = Array.from(this.tableDataSet, ([name, value]) => (value))
      });
  }

  queryParams(noPageSize, sortField) {

    const queryParams = new Object();
    // sort order as number, 1 for asc and -1 for dec
    queryParams['sortParam'] = { sortField: sortField, sortOrder: 1 };
    if (!noPageSize) {
      queryParams['pageParam'] = {
        page:
          this.first / this.pageSize > 1
            ? this.first / this.pageSize + 1
            : this.first / this.pageSize,
        size: this.pageSize
      };
    }
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
  }

  queryParamsDropDownFilter() {
    let queryParams = new Object();
    //sort order as number, 1 for asc and -1 for dec
    queryParams["sortParam"] = { sortField: "name", sortOrder: 1 };
    queryParams["pageParam"] = {
      page:
        this.first / this.pageSize > 1
          ? this.first / this.pageSize + 1
          : this.first / this.pageSize,
      size: this.pageSize
    };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
  }

  downloadTemplate() {


    let header: any = ['Interviewer Name', 'Email', 'Technology Group', 'Date (DD-MMM-YYYY)', 'Time (24-hr)'];
    const csvArray = header.join(',');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = 'content-template.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);


  }

  uploadFile() {
    if (this.fileToUpload) {
      const formData = new FormData();
      formData.append("file", this.fileToUpload, this.fileToUpload.name);
      formData.append("user", JSON.parse(localStorage.getItem("currentUser")).user.id);
      this.httpClient
        .post(`${environment.apiUrl}/interview/upload?file`, formData).subscribe(res => {
          this.display = false;
          this._toastService.add({ severity: 'success', summary: "File uploaded successfully.", detail: '' });
          this.getDashboarData()
        },
          error => {
            this._toastService.add({ severity: 'error', summary: error, detail: '' });
          });
    }

  }
  close() {

    this.myFileInput.nativeElement.value = '';
  }


}
